export enum SmartDetectOutput {
  BenchToeCrest = 'Bench Toe & Crest',
  BuildingFootprintsWithRoofTypes = 'Building Footprints (with roof types)',
  DrainageAnalysis = 'Drainage Analysis',
  HeapDetection = 'Heap Detection',
  MetalledRoads = 'Metalled Roads',
  PondsAndLakes = 'Ponds and Lakes',
  RiversAndStreams = 'Rivers and Streams',
  TreeCanopies = 'Tree Canopies',
  UnMetalledRoads = 'Un-metalled Roads',
  BoreholeDetection = 'Borehole Detection',
  FoundationPilingDetection = 'Foundation Piling Detection',
  PurlinDetection = 'Purlin Detection',
  SolarPanelDetection = 'Solar Panel Detection',
  DrillHoleDetection = 'Drillhole Detection',
  VegetationCoverDetection = 'Vegetation Cover Detection',
}

export const SmartDetectOutputMapping = {
  [SmartDetectOutput.BenchToeCrest]: 'bench_toe_crest',
  [SmartDetectOutput.BuildingFootprintsWithRoofTypes]:
    'building_footprints_or_roof_tops',
  [SmartDetectOutput.DrainageAnalysis]: 'drainage_analysis',
  [SmartDetectOutput.HeapDetection]: 'heap_detection',
  [SmartDetectOutput.MetalledRoads]: 'metalled_roads',
  [SmartDetectOutput.PondsAndLakes]: 'ponds_and_lakes',
  [SmartDetectOutput.RiversAndStreams]: 'rivers_and_streams',
  [SmartDetectOutput.TreeCanopies]: 'tree_canopies',
  [SmartDetectOutput.UnMetalledRoads]: 'unmetalled_roads',
  [SmartDetectOutput.BoreholeDetection]: 'borehole_detection',
  [SmartDetectOutput.FoundationPilingDetection]: 'foundation_piling_detection',
  [SmartDetectOutput.PurlinDetection]: 'purlin_detection',
  [SmartDetectOutput.SolarPanelDetection]: 'solar_panel_detection',
  [SmartDetectOutput.DrillHoleDetection]: 'drill_hole_detection',
  [SmartDetectOutput.VegetationCoverDetection]: 'vegetation_cover_detection',
};

export const SmartDetectOutputLayerPrefixNameMapping = {
  [SmartDetectOutput.BenchToeCrest]: 'Bench Toe/Crest',
  [SmartDetectOutput.BuildingFootprintsWithRoofTypes]: 'Tiled Roofs',
  [SmartDetectOutput.DrainageAnalysis]: 'Drainage Analysis',
  [SmartDetectOutput.HeapDetection]: 'Heaps Boundary',
  [SmartDetectOutput.MetalledRoads]: 'Metalled Roads',
  [SmartDetectOutput.PondsAndLakes]: 'Ponds and Lakes',
  [SmartDetectOutput.RiversAndStreams]: 'Rivers and Streams',
  [SmartDetectOutput.TreeCanopies]: 'Tree Canopies',
  [SmartDetectOutput.UnMetalledRoads]: 'Unmetalled Roads',
  [SmartDetectOutput.BoreholeDetection]: 'Boreholes',
  [SmartDetectOutput.FoundationPilingDetection]: 'Pilings',
  [SmartDetectOutput.PurlinDetection]: 'Purlins',
  [SmartDetectOutput.SolarPanelDetection]: 'Solar Panels',
  [SmartDetectOutput.DrillHoleDetection]: 'Drillholes',
  [SmartDetectOutput.VegetationCoverDetection]: 'Vegetation Cover Detection',
};

// TODO: Move this enum to shared and reuse in heap management.
export enum FormErrorMessages {
  LayerNameNotProvided = 'Layer name is required',
  NoActiveWorkspaceLayer = 'There are no layers in the workspace. Please add layers and try again.',
}
